<template>
    <footer class="footer text_11">
        <div class="container">
            <div class="footer__logo">
                <img v-lazy-load data-src="/img/logo-footer.png" v-lazy-load data-srcset="/img/logo-footer@2x.png 2x" alt="" />
            </div>
            <div class="footer__text">
                {{ $t("footer_text") }}
            </div>

            <OpenBlockButBetter :state="activeBlock === 1">
                <template slot-scope="{ toggle }">
                    <div class="menu">
                        <div
                            class="menu__label"
                            @click="
                                () => {
                                    showBlock(1);
                                    toggle();
                                }
                            ">
                            {{ $t("help") }}
                            <svg-icon name="arrow-down--16" width="16" height="16" />
                        </div>
                        <div class="menu__list-wrapper open-block-but-better__wrapper">
                            <ul class="menu__list">
                                <li class="menu__item">
                                    <nuxt-link to="/dostavka/">{{ $t("help_delivery") }}</nuxt-link>
                                </li>
                                <li class="menu__item">
                                    <nuxt-link to="/vozvrat/">{{ $t("return") }}</nuxt-link>
                                </li>
                                <li class="menu__item">
                                    <nuxt-link to="/faq/">{{ $t("faq") }}</nuxt-link>
                                </li>
                                <li class="menu__item">
                                    <nuxt-link to="/payment/">{{ $t("payment") }}</nuxt-link>
                                </li>
                                <li class="menu__item">
                                    <nuxt-link to="/dokumenty/">{{ $t("docs") }}</nuxt-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
            </OpenBlockButBetter>
            <OpenBlockButBetter :state="activeBlock === 2">
                <template slot-scope="{ toggle }">
                    <div class="menu">
                        <div
                            class="menu__label"
                            @click="
                                () => {
                                    showBlock(2);
                                    toggle();
                                }
                            ">
                            {{ $t("about") }}
                            <svg-icon name="arrow-down--16" width="16" height="16" />
                        </div>
                        <div class="menu__list-wrapper open-block-but-better__wrapper">
                            <ul class="menu__list">
                                <li class="menu__item">
                                    <nuxt-link to="/lookbook/fw26-27/">{{ $t("lookbook-footer") }}</nuxt-link>
                                </li>
                                <li class="menu__item">
                                    <nuxt-link to="/magaziny/">{{ $t("stores") }}</nuxt-link>
                                </li>
                                <li class="menu__item">
                                    <nuxt-link to="/kontakty/">{{ $t("contacts") }}</nuxt-link>
                                </li>
                                <li class="menu__item">
                                    <nuxt-link to="/vacancies/">{{ $t("vacancies") }}</nuxt-link>
                                </li>
                                <li class="menu__item">
                                    <nuxt-link to="/agndr/">{{ $t("become_agndr") }}</nuxt-link>
                                </li>
                                <li class="menu__item">
                                    <nuxt-link to="/loyalty-program/">{{ $t("pps_club_program") }}</nuxt-link>
                                </li>
                                <li class="menu__item">
                                    <nuxt-link to="/gift-card">{{ $t("gift-certificates") }}</nuxt-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
            </OpenBlockButBetter>
            <OpenBlockButBetter :state="activeBlock === 3">
                <template slot-scope="{ toggle }">
                    <div class="menu">
                        <div
                            class="menu__label"
                            @click="
                                () => {
                                    showBlock(3);
                                    toggle();
                                }
                            ">
                            {{ $t("contact_us") }}
                            <svg-icon name="arrow-down--16" width="16" height="16" />
                        </div>
                        <div class="menu__list-wrapper open-block-but-better__wrapper">
                            <ul class="menu__list">
                                <li
                                    class="menu__item"
                                    v-if="
                                        $store.getters['globalvars/getShowContactPhone'] &&
                                        $store.getters['globalvars/getLang'] &&
                                        $store.getters['globalvars/getLang'] === 'ru'
                                    ">
                                    <a :href="'tel:' + $store.getters['globalvars/getContactPhone']">{{
                                        $store.getters["globalvars/getContactPhone"]
                                    }}</a>
                                    <span class="color-text_3">9:00 - 21:00</span>
                                </li>
                                <li class="menu__item">
                                    <a href="mailto:help@pps-office.com">help@pps-office.com</a>
                                </li>
                                <li>
                                    <SocialLinks type="messenger" />
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
            </OpenBlockButBetter>
            <div class="footer__socials">
                <SocialLinks />
            </div>
            <Subscribe target="basement" />

            <div class="footer__bottom">
                <span>p.p.s {{ year }}</span>
                <nuxt-link to="/karta-saita">{{ $t("site_map") }}</nuxt-link>
            </div>
        </div>
    </footer>
</template>
<script>
import Subscribe from "./Subscribe";
import SocialLinks from "./SocialLinks";
import OpenBlockButBetter from "./OpenBlockButBetter";
export default {
    name: "Footer",
    components: { Subscribe, SocialLinks, OpenBlockButBetter },
    data() {
        return {
            year: new Date().getFullYear(),
            activeBlock: 0,
        };
    },
    methods: {
        showBlock(id) {
            this.activeBlock === id ? (this.activeBlock = 0) : (this.activeBlock = id);
        },
    },
};
</script>
<style scoped lang="less">
.page-product-slug,
#productModal {
    .footer {
        padding-bottom: 64px;
    }
}
.footer {
    background: @bg;
    border-top: 1px solid @border2;
    padding-top: 16px;
    &__logo {
        margin-bottom: 40px;
    }
    &__text {
        margin-bottom: 40px;
        text-align: justify;
    }
    &__socials {
        padding: 16px 0;
    }
    &__bottom {
        padding: 24px 0;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
}
.social {
    padding: 24px 0;
}
.menu {
    border-bottom: 1px solid @border2;
    margin: 0 -16px;
    &__label {
        height: 44px;
        padding: 13px 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        svg {
            .trs(transform);
        }
        .is_open & {
            svg {
                transform: rotate(180deg);
            }
        }
    }
    &__list {
        padding: 8px 16px 24px;
    }
    &__item {
        & + & {
            margin-top: 12px;
        }
    }
    .social {
        @media @sm {
            padding-top: 12px;
            padding-bottom: 0;
        }
    }
}
</style>
